export const CONFIGS = {
    CASE_DEFINITION: 'case_definition',
    ENV_MANAGEMENT: 'env_management',
    CUSTOM_CODE: 'custom_code',
    PROJECT_DASHBOARD: 'project_dashboard',
    INBOX: 'inbox',
    ADMIN_INBOX: 'admin_inbox',
    ENQUIRY_INBOX: 'enquiry_inbox',
    TRANSLATION: 'translation',
    PAGES: 'pages',
    TASK_DISTRIBUTOR: 'task_distributor',
    UI_FONT: 'ui_font',
    UI_CSS: 'ui_css',
    UI_THEME: 'ui_theme',
    HEADER_CONFIG: 'header_config',
    SIDENAV_CONFIG: 'sidenav_config',
} as const;

export type ConfigKeys = keyof typeof CONFIGS;

export const IS_ADMIN_SERVICE = false;
export const HIDE_SPINNER = false;
